import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/situacao',
		component: Base,
		children: [
			{
				path: '',
				name: 'SituacoesList',
				component: List,
				meta: {
					path: '/admin/situacao',
					pai: 'Admin',
					title: 'siS - Situação Equipamento',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Situação Equipamento',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'SituacoesNovo',
				component: Form,
				meta: {
					path: '/admin/situacao',
					pai: 'Admin',
					title: 'siS - Situação Equipamento - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Situação Equipamento',
						class: '',
						active: false,
						url: '/admin/situacao'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'SituacoesEditar',
				component: Form,
				meta: {
					path: '/admin/situacao',
					pai: 'Admin',
					title: 'siS - Situação Equipamento - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Situação Equipamento',
						class: '',
						active: false,
						url: '/admin/situacao'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]